import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ChicagoStatus } from '@core/util/chicago';
import { ICON } from '@core/util/icon';
import {
	CancelModalComponent,
	CancelModalData,
} from '../cancel-modal/cancel-modal.component';
import { TestHooks } from './cancelled.hooks';

@Component({
	selector: 'app-chicago-cancelled',
	templateUrl: './cancelled.component.html',
	styleUrls: ['./cancelled.component.scss'],
	standalone: false,
})
export class ChicagoCancelledComponent {
	testHooks = TestHooks;
	public ICON = ICON;
	public chicagoStatus = ChicagoStatus;

	constructor(private dialog: MatDialog) {}

	openPortal() {
		const data: CancelModalData = {
			status: ChicagoStatus.CANCELLED,
		};

		this.dialog.open(CancelModalComponent, {
			data,
			maxWidth: '450px',
			width: '90%',
		});
	}
}
